var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlotimage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0a0a0a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.59,2.24a9.26,9.26,0,1,0,9.14,9.28A9.25,9.25,0,0,0,10.59,2.24ZM10.47,19.6a8.1,8.1,0,1,1,8.06-8.14A8.12,8.12,0,0,1,10.47,19.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.89,9.78v-2c0-.4.1-.79.57-.81s.58.37.58.77c0,.56,0,1.13,0,1.69,0,1-.13,1.95.85,2.62A.53.53,0,0,1,12,13c-.31.28-.6.13-.91-.07A2.89,2.89,0,0,1,9.89,9.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.56,11.55a.62.62,0,0,1,.69-.64c.36,0,.68.12.7.54s-.3.66-.72.65A.62.62,0,0,1,3.56,11.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.37,11.54c0,.45-.34.55-.69.55s-.69-.15-.69-.57.36-.64.76-.61S17.41,11.09,17.37,11.54Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.49,17a.62.62,0,0,1,.55.7c0,.38-.12.69-.53.7s-.63-.32-.62-.74A.63.63,0,0,1,10.49,17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,5.22c0,.5-.18.79-.58.77a.59.59,0,0,1-.57-.68c0-.42.19-.73.65-.7A.51.51,0,0,1,11,5.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotimage);
export default __webpack_public_path__ + "static/media/slotimage.bd60fa5bf15c3d2f3166b8991b5db000.svg";
export { ForwardRef as ReactComponent };